import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  sendmail: FormGroup;
  test_email = "false";
  spinner: boolean = false;

  constructor(
    private ApiService: ApiServiceService,
    private fb: FormBuilder,
    private router: Router,
    private spinnerService: NgxSpinnerService
  ) {
    this.sendmail = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    this.showSpinner();
  }

  showSpinner(): void {
    this.spinnerService.show();
    setTimeout(() => this.spinnerService.hide(), 100); 
  }

  getemail(email: string): void {
    if (this.sendmail.get('email').valid) {
      this.ApiService.email_check_student(email).subscribe(data => {
        this.test_email = data ? 'false' : 'true';
      });
    }
  }

  close(): void {
    this.router.navigate(['']);
  }

  postdata(forgotForm: FormGroup): void {
    if (forgotForm.valid && this.test_email === 'true') {
      this.spinnerService.show();
      this.spinner=true;
      this.ApiService.sendmail(forgotForm.value.email).subscribe(
        (response: any) => {
          this.spinnerService.hide();
          this.spinner=false;

          if (response.status === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'The password reset OTP has been sent to your registered email!',
              iconColor: '#015792',
              confirmButtonColor: '#015792',
              confirmButtonText: 'OK',
              timer: 3000,
              showConfirmButton: false
            }).then(() => {
              this.router.navigate(['/verify-otp'], { queryParams: { email: forgotForm.value.email } });
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: "Error sending reset link",
              text: response.message,
              iconColor: '#e5183b',
              confirmButtonColor: '#e5183b',
              timer: 3000
            });
          }
        },
        error => {
          this.spinnerService.hide();
          Swal.fire({
            icon: 'error',
            title: "An error occurred",
            text: "Unable to send OTP. Please try again later.",
            iconColor: '#e5183b',
            confirmButtonColor: '#e5183b',
            timer: 3000
          });
        }
      );
    } else {
      this.spinnerService.hide();
      Swal.fire({
        icon: 'error',
        title: "Enter valid details",
        iconColor: '#e5183b',
        confirmButtonColor: '#e5183b',
        timer: 3000,
        showConfirmButton: false
      });
    }
  }
}
